import type { SvgProps } from "@/utils/svg-wrapper";

import React from "react";

import { Svg } from "@/utils/svg-wrapper";

export const BriefcaseIcon: React.FC<SvgProps> = ({ className }) => (
  <Svg className={className} height="24" viewBox="0 0 24 24" width="24">
    <path
      d="M8.89924 22H16.8992C20.9192 22 21.6392 20.39 21.8492 18.43L22.5992 10.43C22.8692 7.99 22.1692 6 17.8992 6H7.89924C3.62924 6 2.92924 7.99 3.19924 10.43L3.94924 18.43C4.15924 20.39 4.87924 22 8.89924 22Z"
      fill="inherit"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M8.89941 6V5.2C8.89941 3.43 8.89941 2 12.0994 2H13.6994C16.8994 2 16.8994 3.43 16.8994 5.2V6"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M14.8994 13V14C14.8994 14.01 14.8994 14.01 14.8994 14.02C14.8994 15.11 14.8894 16 12.8994 16C10.9194 16 10.8994 15.12 10.8994 14.03V13C10.8994 12 10.8994 12 11.8994 12H13.8994C14.8994 12 14.8994 12 14.8994 13Z"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M22.5494 11C20.2394 12.68 17.5994 13.68 14.8994 14.02"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M3.51953 11.27C5.76953 12.81 8.30953 13.74 10.8995 14.03"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </Svg>
);
